import { createSlice } from "@reduxjs/toolkit";
import { createQueryMatcher, createMutationMatcher } from "store/actionMatcher";

const initialState = {
  user: null,
  isLoading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfileError: (state) => {
      state.error = null;
    },
    resetProfile: () => initialState,
  },
  extraReducers: (builder) => {
    // Handle getProfile state
    builder
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "pending"), (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "fulfilled"), (state, { payload }) => {
        state.isLoading = false;
        console.log("Update fulfilled handler running:", payload);
        state.user = payload || null;
      })
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "rejected"), (state, { error }) => {
        state.isLoading = false;
        state.error = error?.data?.message || error.message || "Failed to fetch profile";
      });

    // Handle updateProfile state
    builder
      .addMatcher(createMutationMatcher("profileApi", "updateProfile", "pending"), (state) => {})
      .addMatcher(createMutationMatcher("profileApi", "updateProfile", "fulfilled"), (state, { payload }) => {
        state.user = payload || null;
      })
      .addMatcher(createMutationMatcher("profileApi", "updateProfile", "rejected"), (state, { error }) => {});

    // Handle login state
    builder.addMatcher(createMutationMatcher("authApi", "login", "fulfilled"), (state, { payload }) => {
      state.user = payload?.user;
    });
  },
});

export const { actions: profileActions, reducer: profileReducer } = profileSlice;
export const { setUser, clearProfileError, resetProfile } = profileActions;
export default profileReducer;
